<script setup lang="ts">
import { Dropdown, Menu, MenuItem, Checkbox } from 'ant-design-vue';
import { FilterFilled } from '@ant-design/icons-vue';
import RexButtonV3 from '@/rex-components/RexButtonV3.vue';
import { RexFilterItemsType } from '@/rex-components/rex.comp.types';
import { CSSProperties, Ref, computed, ref } from 'vue';
import { useThemeToken } from '@/utils/theme/useThemeToken';

interface Props {
  items: RexFilterItemsType[];
  initialSelectedKeys?: string[];
  overlayStyle?: CSSProperties;
}
const props = withDefaults(defineProps<Props>(), {
  overlayStyle: () => ({ width: '15rem' }),
  initialSelectedKeys: () => [],
});
const emit = defineEmits(['onFilter']);
const { token } = useThemeToken();

const selectedKeys = ref(props.initialSelectedKeys);
const openDropdown: Ref<boolean> = ref(false);

const allKeys = computed(() => {
  return props.items.map((obj) => obj.key);
});
function onReset() {
  selectedKeys.value = allKeys.value;
}
</script>

<template>
  <div>
    <Dropdown
      :open="openDropdown"
      trigger="click"
      placement="bottomRight"
      :arrow="false"
      :overlayStyle="overlayStyle"
    >
      <div @click="() => (openDropdown = true)" class="rex-filter-field-icon">
        <FilterFilled
          :style="{
            height: '0.55rem',
            color: 'rgba(255, 255, 255, 0.7)',
          }"
        />
      </div>

      <template #overlay>
        <div>
          <Menu
            v-model:selectedKeys="selectedKeys"
            class="rex-filter-field-menu"
            :multiple="true"
          >
            <MenuItem v-for="item in props.items" :key="item.key">
              <Checkbox
                :checked="selectedKeys.indexOf(item.key) >= 0"
                class="rex-filter-field-checkbox"
              />
              {{ item.label }}
            </MenuItem>
          </Menu>

          <div
            :style="{ backgroundColor: token.colorBgElevated }"
            class="rex-filter-field-actions-box"
          >
            <RexButtonV3
              variant="text"
              id="rex-filter-field-reset-btn"
              class="rex-filter-field-btn"
              size="small"
              @onClick="onReset"
            >
              {{ $t('reset') }}
            </RexButtonV3>
            <RexButtonV3
              id="rex-filter-field-ok-btn"
              class="rex-filter-field-btn"
              size="small"
              @onClick="
                () => {
                  openDropdown = false;
                  emit('onFilter', selectedKeys);
                }
              "
            >
              {{ $t('ok') }}
            </RexButtonV3>
          </div>
        </div>
      </template>
    </Dropdown>
  </div>
</template>

<style lang="scss" scoped>
.rex-filter-field-checkbox {
  margin-right: 0.5em;
}
.rex-filter-field-btn {
  height: 2rem;
}
.rex-filter-field-menu {
  border-bottom-left-radius: 0px;
  border-bottom-right-radius: 0px;
}
.rex-filter-field-actions-box {
  @include flex-center-justify(space-between);
  padding: 5px 8px;
}
.rex-filter-field-icon {
  cursor: pointer;
}
</style>
